import { SAVED_PLAYER_DATA_ID } from '../constants/AppConstants';

export default class SaveController {
  constructor({ game }) {
    this.game = game;
    this.dataSlots = this.initSaveSlots();

    /*
     *  TODO : This doesn't appear to be working!
     */
    // console.log('SaveController reading UserData');
    // UserData.read('animaldiner').then((value) => console.log('Value retrieved:', value));
    // UserData.write('animaldiner', { player: {} }).then(() => console.log('Value saved:'));
    // UserData.delete('animaldiner');
  }

  // saves
  initSaveSlots() {
    // create save slots if it doesnt exist
    this.dataSlots = this.loadSlotsData();
    if (!this.dataSlots) {
      this.dataSlots = {};
      this.saveGameSlots();
    }
    return this.dataSlots;
  }

  loadSlotsData() {
    /* jshint sub:true */
    const gameData = {};
    const dataString = gameData[SAVED_PLAYER_DATA_ID];
    if (dataString) {
      return JSON.parse(dataString);
    }
    return false;
  }

  /*
  ===================================================================================
  CREATE AND DELETE
  ===================================================================================
  */

  createNewSaveSlot(playerModel) {
    // read slots data
    this.dataSlots[playerModel.slotindex] = playerModel.serialize();
    this.saveGameSlots();
  }

  deleteSaveSlot(slotindex) {
    // read slots data
    delete this.dataSlots[slotindex];
    this.saveGameSlots();
  }

  /*
  ===================================================================================
  SLOT CONTROL
  ===================================================================================
  */

  savePlayerData(playerModel) {
    this.dataSlots[playerModel.slotindex] = playerModel.serialize();
    this.saveGameSlots();
  }

  loadSaveSlot(slotindex, parseJSON) {
    if (parseJSON) {
      const d = this.dataSlots[slotindex];
      return d ? JSON.parse(this.dataSlots[slotindex]) : false;
    }
    return this.dataSlots[slotindex];
  }

  hasSaveSlot(slotindex) {
    return this.dataSlots[slotindex] !== undefined;
  }

  hasPlayerSaves() {
    if (this.dataSlots) {
      return Object.keys(this.dataSlots).length > 0;
    }

    return false;
  }

  getGameSlots() {
    return this.dataSlots;
  }

  saveGameSlots() {
    // const dataString = JSON.stringify(this.dataSlots);
    // console.log('saveGameSlots', dataString);
  }
}
